import * as React from 'react';

const InformationCircle = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={19} height={19} viewBox="0 0 19 19" {...props}>
        <defs>
            <filter
                id="informationcircle_a"
                width="112.6%"
                height="402.5%"
                x="-6.3%"
                y="-151.2%"
                filterUnits="objectBoundingBox"
            >
                <feMorphology in="SourceAlpha" operator="dilate" radius={1} result="shadowSpreadOuter1" />
                <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
                <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation={40} />
                <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                <feColorMatrix
                    in="shadowBlurOuter1"
                    result="shadowMatrixOuter1"
                    values="0 0 0 0 0.229949097 0 0 0 0 0.461254077 0 0 0 0 0.62647192 0 0 0 0.0533333333 0"
                />
                <feMorphology in="SourceAlpha" operator="dilate" radius={1} result="shadowSpreadOuter2" />
                <feOffset in="shadowSpreadOuter2" result="shadowOffsetOuter2" />
                <feGaussianBlur in="shadowOffsetOuter2" result="shadowBlurOuter2" stdDeviation={12} />
                <feComposite in="shadowBlurOuter2" in2="SourceAlpha" operator="out" result="shadowBlurOuter2" />
                <feColorMatrix
                    in="shadowBlurOuter2"
                    result="shadowMatrixOuter2"
                    values="0 0 0 0 0.231372549 0 0 0 0 0.462745098 0 0 0 0 0.62745098 0 0 0 0.0266666667 0"
                />
                <feMerge>
                    <feMergeNode in="shadowMatrixOuter1" />
                    <feMergeNode in="shadowMatrixOuter2" />
                </feMerge>
            </filter>
            <path id="informationcircle_b" d="M0 0h1920v80H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g transform="translate(-1692 -20)">
                <use xlinkHref="#informationcircle_b" fill="currentColor" filter="url(#informationcircle_a)" />
                <path fill="#FFF" stroke="#EBEBEB" d="M-.5-.5h1921v81H-.5z" />
            </g>
            <g
                fillRule="nonzero"
                stroke="#838FA4"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                transform="translate(1 1)"
            >
                <path d="M10.094 11.688h-.531A1.063 1.063 0 0 1 8.5 10.625V7.969a.53.53 0 0 0-.531-.532h-.532M8.234 4.781a.266.266 0 1 0 0 .531.266.266 0 0 0 0-.53" />
                <circle cx={8.5} cy={8.5} r={7.969} />
            </g>
        </g>
    </svg>
);
export default InformationCircle;
